import { Observable } from 'rxjs';

import { RestfulApiService } from './restful-api.service';
import { Store } from '../model/cris/store';
import { Partner } from '../model/mcp/partner';
import { PartnerMap } from '../model/mcp/partner-map';

class PartnerService extends RestfulApiService<Partner> {
    public linkStore(partner: Partner, store: Store): Observable<PartnerMap> {
        return this.http.post<PartnerMap>(`${this.getAlterUrl(partner)}/link`, { store: store.id });
    }

    public unlinkStore(partner: Partner, store: Store): Observable<PartnerMap> {
        return this.http.post<PartnerMap>(`${this.getAlterUrl(partner)}/unlink`, { store: store.id });
    }

    protected getFormName(): string {
        return 'partner';
    }

    protected getPath(): string {
        return 'partners';
    }
}

export const partnerService = new PartnerService();
